<!-- form title -->
<div class="w-12">
    <form #form="ngForm"
          method="POST">
        @if (model?.data) {
        @for (field of fields; track field; let first = $first) {
        @if(field.label === 'Comments' && (field.field_type === 'text' || field.field_type === 'paragraph')) {
        <input-wrap [required]="true"
                    [messages]="{required: 'Please enter comment' | translate}">
            <textarea class="textarea"
                      maxlength="300"
                      [name]="field.cid"
                      [required]="!!field.required"
                      [(ngModel)]="data[field.cid]"
                      (ngModelChange)="detectChanges()"
                      [muiInput]="'Comment' | translate"></textarea>
        </input-wrap>
        <p class="flex flex-justify-between m-l-4 m-t-1 col-12 c1">
            <span>{{'Characters' | translate}}</span>
            <span>{{(data[field.cid] || '').length}}/300</span>
        </p>
        }
        }
        @if (model?.data?.success_message) {
        <result [status]="status"
                [success]="model?.data?.success_message || ''"
                class="block m-t-3"></result>
        }
        }
    </form>
</div>